/**
 * Whether a picked file can be shown as an `<img>` thumbnail.
 *
 * Only image blobs decode in an `<img>`. Pointing one at a PDF (or any other
 * document) yields a broken image, which the browser then replaces with the
 * element's `alt` text — a long filename rendered inside a 48px box wraps into
 * a column of narrow lines and reads as a broken layout.
 */
export function isPreviewableImage(file: { type: string }): boolean {
  return file.type.startsWith('image/');
}
